import { apiRequest } from "./api";

export function createPayment(payload) {
  return apiRequest("/api/v1/payment/create", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function getPaymentStatus(orderNo) {
  return apiRequest(`/api/v1/payment/status/${encodeURIComponent(orderNo)}`);
}

export function listMyPaymentOrders(params = {}) {
  const search = new URLSearchParams();

  if (params.space_id) search.set("space_id", params.space_id);
  if (params.keyword) {
    search.set("keyword", params.keyword);
  }
  if (params.status) {
    search.set("status", params.status);
  }
  if (params.order_type) {
    search.set("order_type", params.order_type);
  }
  if (params.pay_channel) {
    search.set("pay_channel", params.pay_channel);
  }
  if (params.limit) {
    search.set("limit", String(params.limit));
  }
  if (params.offset) {
    search.set("offset", String(params.offset));
  }
  const query = search.toString();
  return apiRequest(query ? `/api/v1/payment/orders?${query}` : "/api/v1/payment/orders");
}
